<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 12C13.3261 12 14.5979 11.4732 15.5355 10.5355C16.4732 9.59785 17 8.32608 17 7C17 5.67392 16.4732 4.40215 15.5355 3.46447C14.5979 2.52678 13.3261 2 12 2C10.6739 2 9.40215 2.52678 8.46447 3.46447C7.52678 4.40215 7 5.67392 7 7C7 8.32608 7.52678 9.59785 8.46447 10.5355C9.40215 11.4732 10.6739 12 12 12ZM10.2148 13.875C6.36719 13.875 3.25 16.9922 3.25 20.8398C3.25 21.4805 3.76953 22 4.41016 22H19.5898C20.2305 22 20.75 21.4805 20.75 20.8398C20.75 16.9922 17.6328 13.875 13.7852 13.875H10.2148Z"
      fill="currentColor"
    />
  </svg>
</template>
